import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { RouterModule } from '@angular/router';
import { AccordionModule, CollapseModule } from 'ngx-bootstrap';
// import { AccordionModule } from 'ngx-accordion';
import { SelectDropDownModule } from 'ngx-select-dropdown';
import { CreateOrdersModule } from '../create-orders/create-orders.module';

import { SharedModule } from '../shared/shared.module';
import { OrderComponent } from './order.component';
import { ViewAllOrdersComponent } from './view-all-orders/view-all-orders.component';
import { SingleOrderComponent } from './view-single-order/view-single-order.component';

@NgModule({
  imports: [
    BrowserAnimationsModule,
    CommonModule,
    FormsModule,
    RouterModule,
    
    SelectDropDownModule,
    AccordionModule.forRoot(),
    CollapseModule.forRoot(),
    
    SharedModule,
    CreateOrdersModule
  ],
  declarations: [
    ViewAllOrdersComponent,
    OrderComponent,
    SingleOrderComponent,

  ]
})
export class OrderModule {

}